import Vue from "vue";
import Vuex from "vuex";
import * as d3 from "d3";
import * as _ from "lodash";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // host: "http://localhost:1337/v1",
    // host: "https://api.defensoresdelademocracia.mx/v1",
    host: '/v1',
    episodePosts: [],
    selectedJournalist: {},
    selectedPublication: {},
    journalistPublications: [],
    allPublications: [],
    allJournalists: [],
    isMobile: true,
  },
  mutations: {},
  actions: {
    async getPublications({
      state
    }, payload) {
      try {
        const response = await axios.get(state.host + "/publications", {
          params: payload,
        });

        const data = await response.data;
        state.allPublications = data.result.publications;
      } catch (error) {
        console.error(error);
      }
    },
    async getJournalists({
      state
    }) {
      try {
        const response = await axios.get(state.host + "/journalists");
        const data = await response.data;
        state.allJournalists = data.result.journalists;
      } catch (error) {
        console.error(error);
      }
    },
    async getJournalistPublications({
      state
    }, payload) {
      try {
        const response = await axios.get(
          state.host + "/journalist/publications", {
            params: payload,
          }
        );

        const data = await response.data;

        state.selectedJournalist = data.result.journalist;
        state.journalistPublications = data.result.publications;
      } catch (error) {
        console.error(error);
      }
    },
    async getEpisodePosts({
      state,
      commit
    }) {
      try {
        const response = await axios.get(
          state.host + "/wp-json/wp/v2/episode_post?per_page=100"
        );

        const data = await response.data;
        state.episodePosts = data;
      } catch (error) {
        console.error(error);
      }
    },
  },
});